import { Typography, TypographyProps } from '@mui/material';

export const HelperText = ({ children, ...props }: TypographyProps) => {
  return (
    <Typography
      sx={{
        color: 'custom.inputHelperText',
        fontSize: 12,
        fontWeight: 500,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
};
